import { get, post, del } from "src/services/api";

export const getAllDeployments = ({ page, perPage }) =>
  get({ endpoint: "/deploy/multi-services", params: { page, perPage } });

export const createMultiServicesDeploy = (branchDeployerData) =>
  post({ endpoint: "/deploy/multi-services", data: branchDeployerData });

export const deleteMultiServicesDeploy = (releaseName) =>
  del({ endpoint: `/deploy/multi-services/${releaseName}` });

export const getDeploymentStatusByReleaseName = (releaseName) =>
  get({ endpoint: `/deploy/multi-services/${releaseName}/status` });
